import {
  QuickbooksSyncBatchLineInput as SyncQuickbooksBatchLineInput,
  QuickbooksSyncBatchManualLineInput as SyncQuickbooksBatchManualLineInput,
  SyncQuickbooksBatchInput,
  CustomSyncQuickbooksBatchMutation,
  useCustomSyncQuickbooksBatchMutation,
} from "generated/graphql";

export type {
  SyncQuickbooksBatchInput,
  SyncQuickbooksBatchLineInput,
  SyncQuickbooksBatchManualLineInput,
  CustomSyncQuickbooksBatchMutation as SyncQuickbooksBatchMutation,
};

export default function useSyncQuickbooksBatch() {
  return useCustomSyncQuickbooksBatchMutation({
    refetchQueries: ["customGetJob", "customGetJobs"],
  });
}
